import { makeStyles } from "@mui/styles";

const white = "#FFFFFF";
const grey50 = "#FAFAFA";
const grey100 = "#F5F5F5";
const grey200 = "#EEEEEE";
const grey300 = "#E0E0E0";
const grey400 = "#BDBDBD";
const grey500 = "#9E9E9E";
const grey600 = "#757575";
const grey700 = "#616161";
const grey900 = "#212121";
const blue50 = "#E3F2FD";
const blue100 = "#BBDEFB";
const turquoise = "#1ABC9C";

export const useBuscadorGlobalMobileStyles = makeStyles((theme) => ({
  // ── Dialog ────────────────────────────────────────────────────
  dialog: {
    // Dialog fullscreen
  },

  // ── Header ───────────────────────────────────────────────────
  dialogHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1.5, 2),
    borderBottom: "1px solid " + grey200,
    backgroundColor: white,
    minHeight: 56,
  },
  closeButton: {
    marginLeft: "auto",
    color: grey600,
    "&:hover": {
      backgroundColor: grey100,
    },
  },

  // ── Input wrapper ────────────────────────────────────────────
  inputWrapper: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1.5, 2),
    backgroundColor: grey50,
    borderBottom: "1px solid " + grey200,
  },

  // ── Paper input container ────────────────────────────────────
  papelInput: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    backgroundColor: white,
    borderRadius: 8,
    border: "1px solid " + grey300,
    padding: theme.spacing(0.5, 1),
    "&:focus-within": {
      borderColor: turquoise,
      boxShadow: "0 0 0 2px " + blue50,
    },
  },

  // ── Input ────────────────────────────────────────────────────
  input: {
    flex: 1,
    fontSize: "1rem",
    border: "none",
    outline: "none",
    "& fieldset": {
      border: "none",
    },
  },

  // ── Icons ────────────────────────────────────────────────────
  searchIcon: {
    color: grey500,
    fontSize: 24,
    marginRight: theme.spacing(0.5),
    flexShrink: 0,
  },
  loadingIcon: {
    color: turquoise,
    marginRight: theme.spacing(0.5),
    flexShrink: 0,
  },

  // ── Content ─────────────────────────────────────────────────
  dialogContent: {
    padding: 0,
    backgroundColor: white,
    height: "calc(100vh - 120px)",
    overflow: "auto",
    "&::-webkit-scrollbar": { width: 6 },
    "&::-webkit-scrollbar-track": { background: "transparent" },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: grey300,
      borderRadius: 3,
      "&:hover": { backgroundColor: grey400 },
    },
  },

  // ── Sección vacía ────────────────────────────────────────────
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
    color: grey600,
    textAlign: "center",
  },
  emptyIcon: {
    fontSize: 48,
    marginBottom: theme.spacing(2),
    color: grey400,
  },
  emptyText: {
    fontSize: "0.9rem",
    color: grey600,
  },
}));
